import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./style.css";

export default function Breadcrumbs() {
  const location = useLocation();

  const pathnames = location.pathname.split("/").filter(Boolean);

  const breadcrumbLabels = {
    home: "Início",
    fundChart: "Fundo",
    members: "Membros",
    editProfile: "Editar Perfil",
    userProfile: "Perfil",
    documents: "Documentos",
  };

  function formatLabel(text) {
    return (
      breadcrumbLabels[text] || text.charAt(0).toUpperCase() + text.slice(1)
    );
  }

  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb mb-0">
        <li className="breadcrumb-item">
          <Link to="/home">
            Início
          </Link>
        </li>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join("/")}`;
          const isLast = index === pathnames.length - 1;

          return isLast ? (
            <li className="breadcrumb-item active" key={to} aria-current="page">
              {formatLabel(value)}
            </li>
          ) : (
            <li className="breadcrumb-item" key={to}>
              <Link to={to}>{formatLabel(value)}</Link>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}